import { render, staticRenderFns } from "./BackgroundColor.vue?vue&type=template&id=47db7501&scoped=true&"
import script from "./BackgroundColor.vue?vue&type=script&lang=js&"
export * from "./BackgroundColor.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColor.vue?vue&type=style&index=0&id=47db7501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db7501",
  null
  
)

export default component.exports